var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "show-more-wrapper" },
    [
      _vm.visibleText
        ? _c("div", {
            staticClass: "visible mb-child-0",
            domProps: { innerHTML: _vm._s(_vm.visibleText) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hiddenText != null
        ? [
            _c("v-collapse-wrapper", { staticClass: "mt-16" }, [
              _c("div", {
                directives: [
                  { name: "collapse-content", rawName: "v-collapse-content" }
                ],
                ref: "hiddentext",
                staticClass: "hidden-text mb-child-0",
                domProps: { innerHTML: _vm._s(_vm.hiddenText) }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hiddenText != null,
                      expression: "hiddenText != null"
                    },
                    { name: "collapse-toggle", rawName: "v-collapse-toggle" }
                  ],
                  staticClass: "link-arrow"
                },
                [
                  _vm._v("Lees meer "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }